import { render, staticRenderFns } from "./filters-settings.vue?vue&type=template&id=6c2d2784&"
import script from "./filters-settings.vue?vue&type=script&lang=js&"
export * from "./filters-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports